// src/utils/bagLabelStatus.js
//
// Single source of truth for the Bag Traceability lifecycle status: the ordered
// label set and per-status colors. Mirrors pidStatus.js but with the two-state
// bag-label set (Active / Inactive) mapped from the BagLabels.IsActive bit, and
// consumes the shared var(--color-status-*) tokens from styles/tokens.js.

export const BAG_LABEL_STATUSES = ['Active', 'Inactive'];

const STATUS_STYLE = {
  Active:   { bg: 'var(--color-status-active)',   fg: 'var(--white)' },
  Inactive: { bg: 'var(--color-status-inactive)', fg: 'var(--white)' },
};

// Normalize a raw value to a known label. Accepts the IsActive bit (bool/number)
// or a status string; anything not recognizably active → 'Inactive'.
export function normalizeBagLabelStatus(value) {
  if (value === true || value === 1) return 'Active';
  const s = String(value == null ? '' : value).trim().toLowerCase();
  return (s === 'active' || s === 'true' || s === '1') ? 'Active' : 'Inactive';
}

// { bg, fg } CSS custom-property tokens for a status chip.
export function bagLabelStatusColor(label) {
  return STATUS_STYLE[normalizeBagLabelStatus(label)];
}
